// src/utils/Loader.jsx
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export const Loader = ({ text = "جاري التحميل...", size = 35, sx = {} }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        p: 2,
        ...sx // للسماح بتمرير أي تنسيقات إضافية عند استدعاء المكون
      }}
    >
      <CircularProgress 
        size={size} 
        thickness={4.5} // سمك الدائرة لتبدو أكثر وضوحاً وعصرية
        sx={{ 
          color: 'primary.main',
          animationDuration: '700ms', // دوران أسرع قليلاً وأكثر سلاسة
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round', // السر هنا: حواف دائرية لخط التحميل بدلاً من الحواف الحادة
          },
        }} 
      />
      
      {/* عرض النص فقط إذا تم تمريره */}
      {text && (
        <Typography 
          variant="body2" 
          sx={{ 
            mt: 1.5, 
            color: 'text.secondary', 
            fontWeight: 600,
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;